import styled from 'styled-components';

export const StyledLoginLayoutWrapper = styled.div`
  min-height: 100vh;
  max-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.brand.navy};
  background-image: radial-gradient(
      circle at 12% 18%,
      ${({ theme }) => theme.colors.brand.yellow}1A,
      transparent 45%
    ),
    radial-gradient(
      circle at 92% 82%,
      ${({ theme }) => theme.colors.brand.green}1F,
      transparent 50%
    ),
    linear-gradient(
      135deg,
      ${({ theme }) => theme.colors.brand.navy} 0%,
      #14195a 100%
    );
  display: flex;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: -4rem;
    left: -6rem;
    width: 32rem;
    height: 32rem;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 280' fill='none'><g stroke='%23FBB03B' stroke-width='1.6' stroke-linejoin='round' stroke-linecap='round' opacity='0.5'><path d='M40 80l60-30 60 30v60l-60 30-60-30z'/><path d='M40 80l60 30M160 80l-60 30M100 110v60'/><path d='M30 70l-12-3M30 70l-10 8M40 80l-18-2'/></g></svg>");
    background-repeat: no-repeat;
    background-size: contain;
    opacity: 0.9;
    pointer-events: none;
  }
  &::after {
    content: '';
    position: absolute;
    bottom: -8rem;
    right: -6rem;
    width: 28rem;
    height: 28rem;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 280' fill='none'><g stroke='%2377B05C' stroke-width='1.4' stroke-linejoin='round' stroke-linecap='round' opacity='0.4'><path d='M150 175l40-20 40 20v40l-40 20-40-20z'/><path d='M150 175l40 20M230 175l-40 20M190 195v40'/></g></svg>");
    background-repeat: no-repeat;
    background-size: contain;
    pointer-events: none;
  }
`;
